import React, { FC } from 'react'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { FrequentQuestionSkeletonContainer } from './styles'

export const QuestionSkeleton: FC = () => (
  <FrequentQuestionSkeletonContainer>
    <section>
      <Skeleton width="100%" height="10px" />
      <Skeleton width="70%" height="10px" />
    </section>
    <section>
      <Skeleton width="90%" height="10px" />
      <Skeleton width="65%" height="10px" />
    </section>
    <section>
      <Skeleton width="100%" height="10px" />
      <Skeleton width="75%" height="10px" />
    </section>
    <section>
      <Skeleton width="95%" height="10px" />
      <Skeleton width="70%" height="10px" />
    </section>
    <section>
      <Skeleton width="100%" height="10px" />
      <Skeleton width="65%" height="10px" />
    </section>
    <section>
      <Skeleton width="100%" height="10px" />
      <Skeleton width="75%" height="10px" />
    </section>
    <section>
      <Skeleton width="95%" height="10px" />
      <Skeleton width="70%" height="10px" />
    </section>
  </FrequentQuestionSkeletonContainer>
)
